export const initialState = {
  currentFilters: {}
}

export default function(state=initialState, action) {
  const { payload, type } = action

  switch(type) {
    case 'SHOP_ORDER_FILTERS_UPDATE':
      return {
        ...state,
        currentFilters: {
          ...state.currentFilters,
          ...payload
        }
      }
    default:
      return state
  }
}
